import React from 'react'
import { withTranslation } from 'react-i18next'

import './PriceBox.scss'

const PriceBox = ({ title, price, style, t }) => (
    <div className="price-box-column" style={style}>
        <p className="price-box-column__header">{title}</p>
        <div className="price-box-column__price">
            <span className="price-box-column__sup">$</span>
            <span className="price-box-column__sum">{price}</span>
        </div>
        <div className="price-box-column__description">
            <span>{price === 0 ? t('_components._price_table._price_box.no_card') : `/${t('_common.month')}`}</span>
        </div>
    </div>
)

export default withTranslation('translations')(PriceBox)
